import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const FavoriteHollowIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FavoriteHollow",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m15.99 6.53 1.71 5.28a3.17 3.17 0 0 0 2.99 2.15h5.54l-4.45 3.25c-1.1.8-1.57 2.21-1.15 3.52l1.71 5.26-4.5-3.26c-.54-.38-1.18-.58-1.84-.58s-1.31.21-1.85.6L9.67 26l1.72-5.27c.41-1.3-.05-2.71-1.15-3.51l-4.47-3.25h5.52c1.35 0 2.56-.86 3-2.17l1.7-5.26m0-3.91c-.12 0-.23.02-.35.05-.35.11-.62.39-.74.74l-2.51 7.75c-.16.47-.6.79-1.1.79H3.16c-.63 0-1.15.51-1.16 1.14 0 .37.18.72.48.94l6.59 4.79c.4.29.57.81.42 1.28l-2.52 7.74a1.144 1.144 0 0 0 1.09 1.51c.24 0 .48-.08.68-.22l6.59-4.78c.2-.14.44-.22.68-.22s.48.07.68.22l6.59 4.78c.21.15.44.23.68.23.35 0 .7-.16.93-.47.22-.3.28-.69.16-1.05l-2.51-7.74c-.15-.47.02-.99.42-1.28l6.56-4.79c.51-.37.63-1.09.26-1.6-.22-.3-.57-.48-.94-.48H20.7c-.5 0-.94-.32-1.1-.79l-2.51-7.75c-.16-.49-.61-.79-1.1-.79"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.04 31.4c-.16 0-.32-.03-.46-.1l-8.72-3.88-8.72 3.88a1.14 1.14 0 0 1-1.6-1.16l1-9.49-6.39-7.09c-.27-.3-.36-.73-.24-1.12.13-.39.45-.68.85-.77l9.33-1.99 4.78-8.25c.41-.71 1.57-.71 1.98 0l4.77 8.26 9.33 1.99c.4.08.72.38.85.77s.04.81-.24 1.12l-6.38 7.09.99 9.49a1.135 1.135 0 0 1-1.13 1.26Zm-9.18-6.37c.16 0 .32.03.46.1l7.37 3.28-.84-8.03c-.03-.32.07-.64.29-.88l5.4-6-7.9-1.68c-.32-.07-.59-.27-.75-.55l-4.04-6.99-4.04 6.99c-.16.28-.44.48-.75.55L3.17 13.5l5.4 6c.22.24.32.56.29.88l-.84 8.03 7.37-3.28c.15-.07.31-.1.46-.1Z"
      })
    })
  }));
};
FavoriteHollowIcon.displayName = 'FavoriteHollowIcon';